/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: Ht1M6qhEEAnx

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  hasVariant,
  PlasmicIcon as PlasmicIcon__,
  renderPlasmicSlot,
  SingleChoiceArg,
  StrictProps,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_data_binding.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicMessagePartLabel.module.css"; // plasmic-import: Ht1M6qhEEAnx/css

import CheckCircleIcon from "../plasmic_kit/PlasmicIcon__CheckCircle"; // plasmic-import: gU-8UYs9RllyJ/icon
import InfoIcon from "../plasmic_kit/PlasmicIcon__Info"; // plasmic-import: BjAly3N4fWuWe/icon
import Sparkles3Icon from "./icons/PlasmicIcon__Sparkles3"; // plasmic-import: udef47udLQ/icon
import SpinnerIcon from "./icons/PlasmicIcon__Spinner"; // plasmic-import: EfDOV4MDLj/icon

createPlasmicElementProxy;

export type PlasmicMessagePartLabel__VariantMembers = {
  state: "loading" | "done" | "error";
};
export type PlasmicMessagePartLabel__VariantsArgs = {
  state?: SingleChoiceArg<"loading" | "done" | "error">;
};
type VariantPropType = keyof PlasmicMessagePartLabel__VariantsArgs;
export const PlasmicMessagePartLabel__VariantProps = new Array<VariantPropType>(
  "state"
);

export type PlasmicMessagePartLabel__ArgsType = { label?: React.ReactNode };
type ArgPropType = keyof PlasmicMessagePartLabel__ArgsType;
export const PlasmicMessagePartLabel__ArgProps = new Array<ArgPropType>(
  "label"
);

export type PlasmicMessagePartLabel__OverridesType = {
  root?: Flex__<"div">;
  svg?: Flex__<"svg">;
};

export interface DefaultMessagePartLabelProps {
  label?: React.ReactNode;
  state?: SingleChoiceArg<"loading" | "done" | "error">;
  className?: string;
}

const $$ = {};

function PlasmicMessagePartLabel__RenderFunc(props: {
  variants: PlasmicMessagePartLabel__VariantsArgs;
  args: PlasmicMessagePartLabel__ArgsType;
  overrides: PlasmicMessagePartLabel__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "state",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.state,
      },
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs,
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_w2GXN278dkQ2gQTVQnPehW",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootstate_done]: hasVariant($state, "state", "done"),
          [sty.rootstate_error]: hasVariant($state, "state", "error"),
          [sty.rootstate_loading]: hasVariant($state, "state", "loading"),
        }
      )}
    >
      <PlasmicIcon__
        data-plasmic-name={"svg"}
        data-plasmic-override={overrides.svg}
        PlasmicIconType={
          hasVariant($state, "state", "error")
            ? InfoIcon
            : hasVariant($state, "state", "done")
            ? CheckCircleIcon
            : hasVariant($state, "state", "loading")
            ? SpinnerIcon
            : Sparkles3Icon
        }
        className={classNames("all", sty.svg, {
          [sty.svgstate_done]: hasVariant($state, "state", "done"),
          [sty.svgstate_error]: hasVariant($state, "state", "error"),
          [sty.svgstate_loading]: hasVariant($state, "state", "loading"),
        })}
        role={"img"}
      />

      {renderPlasmicSlot({
        defaultContents: (
          <div className={classNames("all", "__wab_text", sty.text___7ZkKz)}>
            {"Text"}
          </div>
        ),
        value: args.label,
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "svg"],
  svg: ["svg"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMessagePartLabel__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMessagePartLabel__VariantsArgs;
    args?: PlasmicMessagePartLabel__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicMessagePartLabel__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicMessagePartLabel__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMessagePartLabel__ArgProps,
          internalVariantPropNames: PlasmicMessagePartLabel__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicMessagePartLabel__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMessagePartLabel";
  } else {
    func.displayName = `PlasmicMessagePartLabel.${nodeName}`;
  }
  return func;
}

export const PlasmicMessagePartLabel = Object.assign(
  // Top-level PlasmicMessagePartLabel renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicMessagePartLabel
    internalVariantProps: PlasmicMessagePartLabel__VariantProps,
    internalArgProps: PlasmicMessagePartLabel__ArgProps,
  }
);

export default PlasmicMessagePartLabel;
/* prettier-ignore-end */
